import React, { useState } from 'react';

let globalActiveTab = 'whatsapp';
const tabListeners = [];

const setGlobalActiveTab = (tab) => {
  globalActiveTab = tab;
  tabListeners.forEach(listener => listener(tab));
};

export const useActiveTab = () => {
  const [activeTab, setActiveTab] = useState(globalActiveTab);

  React.useEffect(() => {
    const listener = (tab) => setActiveTab(tab);
    tabListeners.push(listener);
    return () => {
      const index = tabListeners.indexOf(listener);
      if (index > -1) tabListeners.splice(index, 1);
    };
  }, []);

  return [activeTab, setGlobalActiveTab];
};

export default useActiveTab;
